let Search = {};

Search.init = function() {
  let searchOpen = $('.js-search-open');
  let searchClose = $('.js-search-close');
	let searchForm = $('.js-search-form');
	let searchInput = $('#js-search-input');

  searchOpen.on( 'click', function() {
    searchForm.addClass('show');
	$('body').addClass('search-active');
	$('.navbar-collapse').collapse('hide');

    let targetEl = $( $(this).data('focus') );

    if (targetEl) {
        targetEl.focus();
	}
  });

  searchClose.click( function() {
    searchForm.removeClass('show');
		$('body').removeClass('search-active');
		searchInput.val('')
  });
}

Search.init();



// WEBPACK FOOTER //
// ./scripts/components/search.js